import { useCallback } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';

export const useDashboardUIAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(true);
	const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

	const sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent = useCallback(
		(ticketId: string) => {
			fireUIEvent({
				action: ActionKey.CLICKED,
				actionSubject: ActionSubjectKey.LINK,
				actionSubjectId: ActionSubjectIdKey.MIGRATION_TICKETS_TOP_SECTION_OPEN_SUPPORT_TICKET_LINK,
				source: sourceKey,
				attributes: {
					ticketId,
				},
			});
		},
		[fireUIEvent, sourceKey],
	);

	const sendMigrationTicketsListViewAllButtonClickUIEvent = useCallback(() => {
		fireUIEvent({
			action: ActionKey.CLICKED,
			actionSubject: ActionSubjectKey.LINK,
			actionSubjectId: ActionSubjectIdKey.MIGRATION_TICKETS_TOP_SECTION_VIEW_ALL_LINK,
			source: sourceKey,
			attributes: {},
		});
	}, [fireUIEvent, sourceKey]);

	return {
		sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent,
		sendMigrationTicketsListViewAllButtonClickUIEvent,
	};
};
